<template>
    <div class="ppc-box">
        <div class="caption" v-html='ppcData.caption'></div>
        <div class="ppc-item-box">
            <div class="item-box" v-for='(item,index) in ppcData.centerData' :key='index'>
                <span class="number">{{'0'+(index+1)}}</span>
                <h4 class="item-caption">{{item.caption}}</h4>
                <span class="encaption">{{item.encaption}}</span>
                <p class="chinachenter">{{item.chinachenter}}</p>
                <p class="enchenter">{{item.enchenter}}</p>
            </div>
        </div>
        <div class="advantage-box" id="advantage">
            <div class="caption" v-html='advantageData.caption'></div>
            <div class="addvantage">
                <div class="item-add-box" v-for='(item,index) in advantageData.centerData' :key="index">
                    <div class="myicon" :style='{backgroundImage:"url("+item.icon+")"}'></div>
                    <p class="iconcenter">{{item.title}}</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'PPC',
        data() {
            return {
                ppcData: {
                    caption: '通过PPC广告<br/>我们将全面拓展您的业务<br/>...',
                    centerData: [
                        {
                            caption: '付费搜索广告',
                            encaption: 'Paid search',
                            chinachenter: '积极吸引客户,在Google和Bing上搜索您的产品或服务。',
                            enchenter: 'Get in front of customers actively searching for your product or service on Google and Bing.'
                        },
                        {
                            caption: '付费社交广告',
                            encaption: 'Paid social',
                            chinachenter: '在您未来的客户闲逛的任何地方在Facebook，LinkedIn，Instagram上做广告',
                            enchenter: 'Advertise on Facebook, LinkedIn, Instagram – wherever your future customers hang out.'
                        },
                        {
                            caption: '展示广告',
                            encaption: 'Display',
                            chinachenter: '在客户浏览互联网时将他们的业务置于潜在客户的面前，从而提高品牌知名度。',
                            enchenter: 'Drive brand awareness by putting your business in front of prospects while they browse the internet.'
                        },
                        {
                            caption: '视频广告',
                            encaption: 'video',
                            chinachenter: '在YouTube上，通过专业而难忘的视频广告来吸引数字受众。',
                            enchenter: 'Engage digital audiences with professional and unforgettable video advertising on YouTube.'
                        }
                    ]
                },
                advantageData: {
                    caption: '我们的优势<br/>...',
                    centerData: [
                        {
                            icon: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/%E7%BB%84%20699.png',
                            title: '设计高质量的着陆页，提高广告投放效果。'
                        },
                        {
                            icon: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/%E7%BB%84%20700.png',
                            title: '多维度的竞争对手调研，提炼高转化低难度的关键词'
                        },
                        {
                            icon: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/%E7%BB%84%20701.png',
                            title: '根据公司策略，制定适合您的广告投放策略。'
                        }
                    ]
                }
            }
        }
    }
</script>
<style scoped>
    .ppc-box {
        padding: 119px 0 0 0;
        position: relative;
    }

    .ppc-box::before,
    .advantage-box::before {
        content: '';
        display: block;
        position: absolute;
        width: 1px;
        height: 120px;
        background-color: #707070;
        left: 50%;
    }

    .ppc-box::before,
    .advantage-box::before {
        top: 0;
        transform: translateY(-50%);
    }

    .caption {
        font-size: 40px;
        font-weight: bold;
        line-height: 56px;
        text-align: center;
        color: rgba(28, 28, 28, 1);
        margin-bottom: 100px;
    }

    .ppc-item-box {
        width: 66.25%;
        margin: 0 auto;
        display: grid;
        grid-gap: 5%;
        grid-template-columns: 1fr 1fr;
        padding-bottom: 185px;
    }

    .item-box {
        background-color: #ffffff;
        height: 448px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 5%;
    }

    .number {
        font-size: 40px;
        font-weight: 400;
        line-height: 60px;
        color: #ffffff;
        -webkit-text-stroke: 1px rgba(36, 136, 248, 1);
        text-stroke: 1px rgba(36, 136, 248, 1);
        border-bottom: 4px solid #000;
        margin-bottom: 24px;
    }

    .item-caption {
        font-size: 24px;
        font-weight: bold;
        color: #333333;
        margin-bottom: 6px;
    }

    .encaption {
        color: #999999;
        font-size: 14px;
        text-transform: uppercase;
    }

    .chinachenter {
        font-size: 16px;
        line-height: 150%;
        font-weight: bold;
        color: #1c1c1c;
        max-width: 376px;
        text-align: center;
        margin-top: 50px;
    }

    .enchenter {
        font-size: 16px;
        line-height: 118%;
        color: #999999;
        max-width: 376px;
        text-align: center;
        margin-top: 20px;
    }

    .advantage-box {
        padding: 125px 0 219px 0;
        background-color: #ffffff;
        position: relative;
    }

    .addvantage {
        display: grid;
        width: 65.5%;
        margin: 0 auto;
        grid-template-columns: 1fr 1fr 1fr;
        grid-column-gap: 10%;
    }

    .myicon {
        width: 100px;
        height: 100px;
        background: transparent no-repeat center center;
        background-size: 90%;
        margin-bottom: 66px;
    }

    .item-add-box {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
    }

    .iconcenter {
        font-size: 20px;
        font-weight: bold;
        line-height: 28px;
        color: rgba(102, 102, 102, 1);
        text-align: center;
    }

    @media(max-width: 995px){
        .ppc-box::before,
    .advantage-box::before {
        display: none;
    }
    .ppc-box {
        padding: 5% 0;
    }
    .caption {
        font-size: 24px;
        line-height: 140%;
        margin-bottom: 5%;
    }
    .ppc-item-box {
        width: 100%;
        margin: 0 auto;
        display: grid;
        grid-gap: 1%;
        grid-template-columns: 1fr;
        padding-bottom:10%;
    }
    .item-box {
        height: auto;
    }
    .chinachenter {
        max-width: 100%;
        text-align: center;
        margin-top: 4%;
    }
    .number {
        font-size: 24px;
        line-height: 150%;
        margin-bottom: 1%;
    }
    .addvantage {
        display: grid;
        width:100%;
        margin: 0 auto;
        grid-template-columns: 1fr;
        grid-column-gap:0%;
    }
    .myicon {
        margin-bottom: 0px;
    }
    .advantage-box {
        padding:5%;
        background-color: #ffffff;
        position: relative;
    }
    .item-add-box {
        padding-bottom: 5%;
    }
    .iconcenter {
        font-size: 16px;
        line-height: 140%;
    }
    }

    /* @media(max-width: 1023px) {
        .caption {
            font-size: 75px;
            line-height: 140%;
        }

        .ppc-item-box {
            width: 100%;
            grid-template-columns: 1fr;
            padding: 0 5% 185px;
        }

        .number {
            font-size: 75px;
            line-height: 150%;
        }

        .item-caption {
            font-size: 65px;
        }

        .encaption {
            font-size: 30px;
        }

        .chinachenter {
            font-size: 50px;
            line-height: 150%;
            max-width: 100%;
            text-align: left;
        }

        .enchenter {
            font-size: 50px;
            line-height: 118%;
            max-width: 100%;
            text-align: left;
        }

        .item-box {
            background-color: #ffffff;
            height: auto;
            padding: 10% 5%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }

        .myicon {
            width: 300px;
            height: 300px;
        }

        .iconcenter {
            font-size: 50px;
            line-height: 140%;
            max-width: 80%;
        }

        .addvantage {
            display: grid;
            width: 100%;
            margin: 0 auto;
            grid-template-columns: 1fr;
            grid-column-gap: 4%;
            grid-row-gap: 5%;
            padding: 0 5%;
        }

        .advantage-box {
            padding: 125px 0 419px 0;
        }
    } */
</style>


// WEBPACK FOOTER //
// src/components/main/project/ppc.vue